<lib-generic-dropdown
    name="buildingContactRole"
    id="buildingContactRole"
    [(selectedItem)]="selectedRole"
    (selectedItemChange)="onBuildingContactRoleChange()"
    [source]="buildingContactRoles"
    [config]="{
        defaultText: 'Select Contact Role',
        itemDisplayKey: 'name'
    }"
    [isReadOnly]="isReadOnly"
></lib-generic-dropdown>
